import { useTheme } from '@backoffice-frontend/patterns'
import type { ReactNode } from 'react'

type MapLegendProps = {
  children: ReactNode
  position: 'bottom-left' | 'bottom-right' | 'top-right' | 'top-left' | 'custom'
  orientation?: 'vertical' | 'horizontal'
  customPosition?: string
}

/**
 * MapLegend is a wrapper that places legend elements on the map.
 * It should be used as a direct child of the `HereMap` component.
 * @param children The legend elements (e.g. ZoomButtons)
 * @param position Where the legend should be placed on the map.
 * @param orientation The orientation of the legend elements. The default is `vertical`.
 */
export const MapLegend = (props: MapLegendProps) => {
  const theme = useTheme()

  const inset =
    props.position === 'bottom-left'
      ? theme.spacing('auto', 'auto', 2, 2)
      : props.position === 'bottom-right'
        ? theme.spacing('auto', 2, 2, 'auto')
        : props.position === 'top-right'
          ? theme.spacing(2, 2, 'auto', 'auto')
          : props.position === 'top-left'
            ? theme.spacing(2, 'auto', 'auto', 2)
            : props.position === 'custom'
              ? props.customPosition
              : undefined

  return (
    <div
      css={theme => ({
        position: 'absolute',
        zIndex: 2,
        inset,
        display: 'flex',
        flexDirection: props.orientation === 'horizontal' ? 'row' : 'column',
        gap: theme.spacing(1),
      })}
    >
      {props.children}
    </div>
  )
}
